import type Guid from "_shared/guids/guid";

/**
 * Where one person's permissions live: `/permissions/people/{userId}`, and `/permissions/people/me`
 * for the viewer's own, which every member may open from the avatar menu.
 */

export const OWN_PERMISSIONS_SEGMENT = "me";
export const OWN_PERMISSIONS_PATH = `/permissions/people/${OWN_PERMISSIONS_SEGMENT}`;

/**
 * The person page's query string: which per-record list is open (a kind's slug), its page (from 1),
 * its name search, and the one record it is narrowed to after a change from Add access. Back closes a
 * list because opening one is a navigation.
 */
export const RECORDS_PARAM = "records";
export const RECORDS_PAGE_PARAM = "page";
export const RECORDS_QUERY_PARAM = "q";
export const RECORDS_TARGET_PARAM = "record";

export function personPermissionsPath(userId: Guid, records?: string): string {
  const path = `/permissions/people/${userId.value}`;
  return records ? `${path}?${new URLSearchParams({ [RECORDS_PARAM]: records }).toString()}` : path;
}
